<script>
import { required } from 'vuelidate/lib/validators'

const mustBeTrue = (value) => value == true;

export default {
	data() {
		return {
        	accept: false,
		}
	},
	validations: {
		accept: { required, mustBeTrue },
		form: ['accept' ],
	},
	methods: {
		validate() {
			this.$v.form.$touch()
			var isValid = !this.$v.form.$invalid
			this.$emit('on-validate', this.$data, isValid)
			return isValid
		},
	},
}
</script>

<template>
	<div>
		<div class="row">
			<div class="col-12">

				<div class="therms-text">
					<h2>TERMO DE ADESÃO PARA UTILIZAÇÃO DA LISTA DE CASAMENTO</h2>
					<br />
					<p><strong>LISTA DE CASAMENTO: OPÇÃO CRÉDITO</strong></p>
					<br>
					<p>1.	OS PRESENTES RECEBIDOS SERÃO 100% CONVERTIDOS EM CRÉDITOS EM REAIS (R$) QUE SERÃO ACUMULADOS NO NOME DOS NOIVOS DE ACORDO COM CPF E E-MAIL CADASTRADOS.</p>
					<p>2.	OS CRÉDITOS PODERÃO SER RESGATADOS TANTO ONLINE QUANTO EM LOJAS FÍSICAS LA VILLE, OU NO SITE DAS LOJAS PARCEIRAS. (*CONSULTAR LOJAS PARCEIRAS E CONDIÇÕES)</p>
					<p>3.	OS CRÉDITOS SÃO VÁLIDOS POR TEMPO INDETERMINADO.</p>
					<p>4.	O CONVIDADO NÃO PAGA FRETE. O FRETE SERÁ COBRADO DE ACORDO COM A POLÍTICA DO SITE LAVILLE OU DOS SITES DAS LOJAS PARCEIRAS.</p>
					<p>5.	CASO O PRESENTEANTE SOLICITE A ENTREGA DO  PRESENTE, A VENDA SERÁ REALIZADA FORA DA LISTA E NÃO ACUMULARÁ CRÉDITO. A TROCA DESSE PRODUTO SÓ PODERÁ SER REALIZADA NAS LOJAS FISÍCAS. O CRÉDITO DESSE PRESENTE NÃO PODERÁ SER UTILIZADO ONLINE. </p>
					<br />
					<br />
					<p><strong>CONDIÇÕES GERAIS</strong></p>
					<br />
					<p>1.	A LISTA FICARÁ DISPONÍVEL NO SITE ATÉ 90 DIAS APÓS A DATA DO EVENTO.</p>
					<p>2.	SEMPRE QUE GANHAR UM PRESENTE, VOCÊ RECEBERÁ UM E-MAIL COM O NOME DO PRESENTEANTE, A MENSSAGEM DO CARTÃO E O VALOR DO PRESENTE.</p>
					<p>3.	A LISTA PODERÁ SER GERENCIADA DIRETAMENTE NO SITE ONDE TAMBÉM FICA DISPONÍVEL UM RELATÓRIO COM AS INFORMAÇÕES DOS PRESENTES GANHOS, NOTAS FISCAIS E MENSAGENS DOS CARTÔES.</p>
					<p>4.	OS PREÇOS DOS PRODUTOS PODEM SER ALTERADOS A QUALQUER MOMENTO SEM AVISO PRÉVIO</p>
					<p>5.	NÃO GARANTIMOS ESTOQUES OU FAZEMOS RESERVAS DE PRODUTOS. NO MOMENTO DO RESGATE DOS CRÉDITOS, OS PRODUTOS ESCOLHIDOS ANTERIORMENTE PODEM NÃO ESTAR MAIS DISPONÍVEIS.</p>
					<br />
					<br />
				</div>

			</div>

			<div class="row">
				<div class="col-12">
					<div class="mb-3">
						<div class="custom-control custom-checkbox">
							<input
								id="accept"
								type="checkbox"
								class="custom-control-input"
								v-model.trim="accept"
								:class="{ 'is-invalid': $v.accept.$error }"
							/>
							<label class="custom-control-label" for="accept"
								>Eu estou de acordo com o regulamento</label
							>
							<span v-if="$v.accept.$error" class="help-block invalid-feedback">Campo obrigatório</span>
						</div>
					</div>
				</div>
			</div>

		</div>
								

	</div>
</template>
